import {useQuery} from '@tanstack/react-query';
import {fetchRest} from '../helpers/fetchRest';
import utils from '../helpers/utils';
import {useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {setShowWarningIconUnified} from '../actions/transactionActions';

/**
 * Custom hook to fetch logged in members connected financial account data
 * @param {string} accountId - user account id to get transactions
 * @param {ProductFeatures} productFeatures - ProductFeatures
 * @return {{isLoading: boolean, isError: boolean, data: ConnectionsResponse, error: object, isSuccess: boolean}}
 *
 */
export const useConnectionsDetails = (accountId: string, productFeatures: ProductFeatures) => {
  const dispatch = useDispatch();
  const url = `${utils.getConnectionsPath()}?groupBy=accounts,connections`;
  const query = useQuery({
    queryKey: ['connections'],
    queryFn: () =>
      fetchRest(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
        },
        credentials: 'include',
      }),
    enabled: !!accountId && utils.isFeaturePresent(productFeatures, 'financialWellness'),
  });
  // Remove onSuccess callback and move to useEffect
  useEffect(() => {
    if (query.data) {
      dispatch(setShowWarningIconUnified(query.data));
    }
  }, [query.data, dispatch]);
  return {...query, isLoading: query.isPending};
};
